
import { ref, computed, onBeforeMount, watch } from 'vue'
import { useStore } from 'vuex'

import nonEmptyStringValidator from "foundation/js/inputValidators/nonEmptyStringValidator";

import FormInputTextField from 'components/FormInputTextField/FormInputTextField.vue' 
import FormCheckbox from 'components/FormCheckbox/FormCheckbox.vue' 
import FormInputDropdown from 'components/FormInputDropdown/FormInputDropdown.vue' 

export default {
    name: 'RequestRole',
    components: {
        FormInputTextField,
        FormCheckbox,
        FormInputDropdown
    },
    setup() {
        const store = useStore()

        const activities = computed(()=> store.state.frivilligprofil.aktivitet_list)
        const roles = computed(()=> store.state.frivilligprofil.rolle_list)
        const groups = computed(()=> store.state.frivilligprofil.gruppe_list)

        onBeforeMount(() => {
            store.dispatch('frivilligprofil/fetchAktiviteter')
        })

        let displayError = ref(false)

        const roleActivityId =  ref('')
        const roleId = ref('')
        const roleGroupId = ref('')
        const roleGroupCheckbox = ref(false)
        const roleGroupTextField = ref('')
        const activitySelectOptions = computed(() => activities.value.map(a =>  {
            return {
                name: a.name,
                value: a.id
            }
        }))
        const groupSelectOptions = computed(() => groups.value.map(g => {
            return {
                name: g.name,
                value: g.kode
            }
        }))
        const roleSelectOptions = computed(() => roles.value.map(a => {
            return {
                name: a.name,
                value: a.id
            }
        }))

        const handleActivitiesSelector = function (e){
            roleActivityId.value = ''

            setTimeout(()=>{
                roleActivityId.value = e.target.value
                displayError.value = false;
            },25)

            // reset of later inputs
            roleId.value = ''
            roleGroupId.value = ''
            roleGroupCheckbox.value = false
            roleGroupTextField.value = ''
        }

        const handleRoleSelector = function (e){
            roleId.value = e.target.value
            displayError.value = false;

            // reset of Group selector
            roleGroupId.value = ''
        }

        const handleGroupSelector = function (e){
            roleGroupId.value = e.target.value

            displayError.value = false;

            roleGroupTextField.value = ''
        }

        const handleGroupCheckbox = function (e){
            roleGroupCheckbox.value = e.target.checked
            displayError.value = false;

            roleGroupId.value = ''

        }

        const handleGroupTextField = function (e){
            roleGroupTextField.value = e.target.value

            roleGroupId.value = ''
            
            if(nonEmptyStringValidator(e.target.value)) {
                displayError.value = false 
            }
        }

        const determinedRoleGroup = function (){
            if(roleGroupId) {
                return roleGroupId
            } else if(roleGroupCheckbox.value && roleGroupTextField.value) {
                return nonEmptyStringValidator(roleGroupTextField.value) ? roleGroupTextField.value : false
            }
        }

        const roleGroupTextFieldFilled = ref(nonEmptyStringValidator(roleGroupTextField.value))

        const isValid = function () {
            return roleActivityId 
                        && roleId 
                        && determinedRoleGroup()   
        }

        const handleSubmitRoleRequest = function (){

            displayError.value = true;
         
            if (!isValid())
                return false

            displayError.value = false;

            const body = {
                aktivitetsId: roleActivityId.value,
                rolleId: roleId.value,
                gruppekode: roleGroupId.value,
                gruppeText: roleGroupTextField.value
            }

            store.dispatch('frivilligprofil/submitRoleRequest', {
                body: body
            })
        }

        watch(
            roleActivityId,
            (newValue, _) => {
                store.dispatch("frivilligprofil/fetchRoller", newValue)
                store.dispatch("frivilligprofil/fetchGrupper", newValue)
            }
        )

        return {
            activities,
            roles,
            groups,
            roleActivityId,
            roleId,
            roleGroupId,
            roleGroupCheckbox,
            roleGroupTextField,
            displayError,
            roleGroupTextFieldFilled,
            activitySelectOptions,
            roleSelectOptions,
            groupSelectOptions,
            handleActivitiesSelector,
            handleRoleSelector,
            handleGroupSelector,
            handleGroupCheckbox,
            handleGroupTextField,
            handleSubmitRoleRequest,
            getLabel: (labelKey) =>
                store.getters["labels/getLabel"]({
                    labelCollection: "requestRole",
                    labelKey,
                }),
        }
    }
}
